/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Children, cloneElement } from 'react';

import { styled } from 'fierry/react';


const SIZES = { 1: 12, 2: 14, 3: 16, 4: 18, 5: 20, 6: 24, 7: 28, 8: 35, 9: 60 };


const Container = styled.span`
  display: inline-flex;
  align-items: center;

  --svg-black: currentColor;
`;


export default ({ size = '1', children }) =>
(
  <Container>
    {Children.map(children, element => cloneElement(element, { size: SIZES[size] }))}
  </Container>
);
